
(function() {
    var focusId;
    $(document).on('focus', 'input[name^=filter][data-autosubmit]', function () {
        focusId = '#' + $(this).attr('id');
    });

    $.nette.ext('snippet-filter', {
        success: function (payload) {
            if (payload.snippets) {
                $('#filter-wrapper').addClass('in').attr('aria-expanded', 'true');
                if ($(focusId).length) {
                    var $input = $(focusId);
                    $input.focus();
                    setTimeout(function(){
                        $input[0].selectionStart = $input[0].selectionEnd = 10000;
                    }, 10);
                }
            }

        }
    });
})();